import React from 'react';
import Box from '@mui/material/Box';

const RequiredIndicator = () => (
    <Box
        component="span"
        sx={{
            color: 'red',
            marginLeft: '0.2rem'
        }}
    >
        *
    </Box>
);

export default RequiredIndicator;
